'use client'

import { useCookies } from 'react-cookie'

import { useCallback, useEffect } from 'react'

import { USER_TOKEN_KEY } from './constants'

import { generateUUIDv4 } from './generate-uuid'
import { UseUserTokenReturnValue, UserTokenKeys, UserTokenValues } from './types'

export default function useUserToken(): UseUserTokenReturnValue {
    const [cookies, setCookies] = useCookies<UserTokenKeys, UserTokenValues>([USER_TOKEN_KEY])

    const userToken = cookies[USER_TOKEN_KEY] ?? null

    const setUserToken = useCallback(
        (userToken: string | null) => {
            const oneYearFromNow = new Date()
            oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)

            setCookies(USER_TOKEN_KEY, userToken, {
                httpOnly: false,
                secure: true,
                sameSite: 'lax',
                expires: oneYearFromNow,
                path: '/',
            })
        },
        [setCookies]
    )

    useEffect(() => {
        if (userToken) return

        if (location.protocol === 'http:') {
            setUserToken('677b70fa-937d-4469-a812-edaafd36fa42')

            return
        }

        setUserToken(generateUUIDv4())
    }, [setUserToken, userToken])

    return [userToken as string, setUserToken]
}
